module.exports = __webpack_public_path__ + "src/assets/textures/molar/table_w_water_lambert14_AO.jpg";